<template>
    <div>
        <div class="container">
            <p class="title">恭喜您已经完成报名！</p>
            <ul><li>预约时间：</li><li>{{datas.date_desc}} {{datas.hour_span}}</li></ul>
            <ul><li>路考考点：</li><li>{{datas.name}}</li></ul>
            <ul><li>考点地址：</li><li>{{datas.address}}</li></ul>
            <ul><li>备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</li><li class="tips">请携带本人身份证及驾驶证原件</li></ul>
            <qrcode></qrcode>
        </div>
        <bottom-layout></bottom-layout>
    </div>
</template>
<script>
import { getSignUpInfo } from '../../../utils/actions'
import qrcode from '../components/QRcode'
import BottomLayout from './BottomLayout'
export default {
  data () {
    return {
      datas: {}
    }
  },
  components: {
    BottomLayout,
    qrcode
  },
  created () {
    this.getSignUpInfo()
  },
  methods: {
    async getSignUpInfo () {
      let _this = this
      let data = await getSignUpInfo({
        id: _this.$store.state.id,
        open_id: _this.$store.state.openid
      })
      if (data && data.data) {
        _this.datas = data.data.road_booking
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
    background: #f7f7f7;
    font-size: .28rem;
    color: #19191A;
    width: 86%;
    height: 7.506rem;
    margin-left: 3%;
    padding: 0 4% 0 4%;
    .title{
        text-align: center;
        margin-bottom: .32rem;
        padding-top: .65rem;
    }
    ul li:first-child{
        width: 25%;
        text-align: left;
        float: left;
    }
    ul li:last-child{
        width: 75%;
        text-align: left;
        float: left;
    }
    li{
        display: inline-block;
    }
    ul{
         line-height: .44rem;
    }
    ul:after{
        content: '';
        display: block;
        clear: both;
    }
    .tips{
        font-size: .28rem;;
        color: #FF5548;
    }
}
.QRcode{
       width: 100%;
       text-align: center;
    p{
       font-size: .24rem;
        color: #19191A;
        padding-bottom: .2rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/pass-status/components/Pass.vue